


















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Button, Card, Form, FormItem, Checkbox } from 'element-ui';

// Types
import {
  CustomerOrganizationFields,
  CustomerOrganizationInput
} from '@/types/graphql/schemaTypes';

// GQL
import updateCustomerOrg from '@/graphql/mutations/customerOrganization/Update.gql';

@Component({
  components: {
    'el-button': Button,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-checkbox': Checkbox
  }
})
export default class NotificationSetting extends Vue {
  @Prop({ required: true }) customerOrganization!: CustomerOrganizationFields;

  editing = false;
  loading = false;

  private customerOrganizationInput: CustomerOrganizationInput = null;

  setInput() {
    this.editing = true;
    this.customerOrganizationInput = {
      id: this.customerOrganization.id,
      includeSender: this.customerOrganization.includeSender || false
    };
  }

  async submit() {
    if (!this.customerOrganizationInput) return;
    const customerOrganizationArgs = this.customerOrganizationInput;

    this.loading = true;

    try {
      const response = await this.$apollo.mutate({
        mutation: updateCustomerOrg,
        variables: {
          customerOrganizationArgs
        }
      });

      if (response) {
        this.editing = false;
        this.$emit('refresh');
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.loading = false;
    }
  }
}
